<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>工作台</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/storelist' }" style="cursor: pointer">客服门店列表</el-breadcrumb-item>
            <el-breadcrumb-item>会员列表</el-breadcrumb-item>
        </el-breadcrumb>
        <br>
        <!-- {{storelist}} -->
         <!-- {{ storeinfo }}
         {{ queryInfo.storeid }} -->
        <el-tabs v-model="activeName"  @tab-click="TabClick">
            <el-tab-pane label="会员列表" name="first">
                <div style="padding-bottom: 15px;">
                    <el-select v-model="queryInfo.storeid"  placeholder="请选择门店" @change="getList()"  style="margin-left:10px" filterable>
                        <el-option v-for="item in storelist" :key="item.id" :label="item.storename" :value="item.id"></el-option>
                    </el-select>
                    <el-input placeholder="请输入手机号后四位 / 手机号搜索" style="width: 400px;margin-left:10px" v-model="queryInfo.query" clearable @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
                    </el-input>
                    <div style="text-align: right;">
                        <!-- <el-button type="primary" icon="el-icon-present" @click="showGiftCardDialog" style="margin-right: 10px;">发放会员卡</el-button> -->
                        <el-button type="success" icon="el-icon-refresh" @click="getList" style="margin-left: 10px;">刷新</el-button>
                    </div>
                </div>
                <el-card>
                    <el-table :data="userList" style="width: 100%" stripe  height="550"  @row-click="handleRowClick"  v-loading="Loading">
                        <el-table-column label="序号" width="100" fixed>
                            <template slot-scope="scope">
                                <!-- {{ scope.$index + 1 }} -->
                                {{ (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column label="入场时间" prop="last_in_time" width="300">
                            <template slot-scope="scope">
                                {{ scope.row.last_in_time || '未签到' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="会员" width="400"  prop="username">
                            <template slot-scope="scope">
                                <el-image :src="`${ossURL}${scope.row.username}.png?t=' + Date.now()`" style="width: 50px; height: 50px; border-radius: 50%; vertical-align:middle;margin-right: 10px; cursor: pointer;" @click.native.stop="showLargeAvatar(scope.row.username)">
                                    <div slot="error" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                                         <img src="@/assets/image/tx.png" style="width:50px;height:50px" />
                                    </div>
                                </el-image>
                                <span>{{ scope.row.username }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="信息" prop="info">
                            <template slot-scope="scope">
                                <!-- 添加调试信息 -->
                                <div v-if="!scope.row.cards || scope.row.cards.length === 0" style="color: #999;">
                                    无会员卡信息
                                </div>

                                <!-- 会员卡信息列表 -->
                                <div v-if="scope.row.cards && scope.row.cards.length > 0" v-for="(card, index) in scope.row.cards" :key="index" style="display: flex;align-items: center;padding-bottom: 10px;">
                                    <el-tag type="success" style="margin-left: 10px;">
                                        {{ card.cardname || '无名称' }}
                                    </el-tag>

                                    <span style="padding-left: 10px;" v-if="card.remaining && card.remaining !='时间格式错误'">剩余：{{ card.remaining }}</span>
                                    <span style="padding-left: 10px;" v-if="card.endtime">到期：{{ card.endtime }}</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <!--分页区域-->
                <br>
                <div align="center">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="queryInfo.pagenum" :page-sizes="[20,50,100,500]"  :page-size="queryInfo.pagesize"
                    layout="total, sizes, prev, pager, next" :total="total">
                    </el-pagination>
                </div>
                <!--分页区域-->
                <!-- 头像放大对话框 -->
                <el-dialog :visible.sync="dialogVisible" title="会员人脸" width="30%">
                    <div style="text-align: center;">
                        <el-image :src="face" style="max-width: 100%; max-height: 500px;">
                            <div slot="error" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
                                    <img src="@/assets/image/tx.png" style="width:500px;height:500px" />
                            </div>
                        </el-image>
                        <p style="margin-top: 20px; font-size: 18px;">手机号: {{ username }}</p>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">关闭</el-button>
                    </span>
                </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="设备管理" name="second">

                <el-card>
                    <!-- {{  }} -->
                    <div slot="header" style="font-size: 20px">
                        <span>门店：{{storeinfo.Storename}}</span>
<!--                        <el-button icon="el-icon-refresh"  style="float: right; padding: 3px 0;font-size: 16px;" type="text" @click="checkHeartbeat"></el-button>-->
                    </div>
                    <div style="margin-bottom: 15px; display: flex; justify-content: space-around;">
                        <div class="store-stat">
                            <i class="el-icon-user"></i>
                            <span>会员数量：{{storeinfo.member_count || 0}}</span>
                        </div>
                        <div class="store-stat">
                            <i class="el-icon-data-line"></i>
                            <span>今日客流：{{storeinfo.visitor_in || 0}}</span>
                        </div>
                    </div>
                    <el-row :gutter="10">
                        <el-col :span="12" style="display: flex;" v-if="storeinfo.doorType == '0'">
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div v-if="!storeinfo.openDoor || storeinfo.openDoor != '0'">门禁一</div>
                                    <div v-else>24小时门禁</div>
                                </div>
                                 <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                   <el-button type="success" @click="publishDoorCommandA(storeinfo.Sn, storeinfo.upDeviceTopic)" style="margin-right: 30px;">A门</el-button>
                                   <el-button type="primary" @click="publishDoorCommand(storeinfo.Sn, storeinfo.upDeviceTopic)">B门</el-button>
                                </div>
                            </div>
                            <div class="cardinfo" v-if="storeinfo.Sn1">
                                <div style="display: flex;justify-content: space-between;">
                                    <div v-if="!storeinfo.openDoor || storeinfo.openDoor != '1'">门禁二</div>
                                    <div v-else>24小时门禁</div>
                                </div>
                                 <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                   <el-button type="success" @click="publishDoorCommandA(storeinfo.Sn1, storeinfo.upDeviceTopic2)" style="margin-right: 30px;">A门</el-button>
                                   <el-button type="primary" @click="publishDoorCommand(storeinfo.Sn1, storeinfo.upDeviceTopic2)">B门</el-button>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12" style="display: flex;" v-else>
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div>进门</div>
                                </div>
                                 <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                   <el-button type="success" @click="publishDoorCommandA(storeinfo.Sn, storeinfo.upDeviceTopic, 'A')" style="margin-right: 30px;">A门</el-button>
                                   <el-button type="primary" @click="publishDoorCommand(storeinfo.Sn, storeinfo.upDeviceTopic, 'B')">B门</el-button>
                                </div>
                            </div>
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div>出门</div>
                                </div>
                                 <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                   <el-button type="success" @click="publishDoorCommandA(storeinfo.Sn, storeinfo.upDeviceTopic, 'OUT-A')" style="margin-right: 30px;">A门</el-button>
                                   <el-button type="primary" @click="publishDoorCommand(storeinfo.Sn,storeinfo.upDeviceTopic, 'OUT-B')">B门</el-button>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12" v-if="storeinfo.newFlag !== 'Y'">
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div>照明</div>
                                    <!-- <div><el-tag type="success">在线</el-tag></div> -->
                                </div>
                                <div style="text-align: center;">
                                    <el-button type="success" @click="publishLightCommand(storeinfo.Boxsn,'a1')">开灯</el-button>
                                    <el-button type="danger" @click="publishLightCommand(storeinfo.Boxsn,'b1')">关灯</el-button>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12" v-if="lyControls.length > 0 && storeinfo.newFlag !== 'Y'">
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div>淋浴</div>
                                    <!-- <div><el-tag type="success">在线</el-tag></div> -->
                                </div>

                                <div style="text-align: center;padding-top: 30px;">
                                    <el-button-group v-for="(ly, index) in lyControls" :key="index">
                                        <el-button type="success" icon="el-icon-switch-button" @click="publishBathCommand(ly.topic,'a' + ly.port)" size="mini">{{ ly.port }}路开</el-button>
                                        <el-button type="danger" icon="el-icon-switch-button" @click="publishBathCommand(ly.topic,'b' + ly.port)" size="mini">{{ ly.port }}路关</el-button>
                                    </el-button-group>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="12" v-if="airdata.length > 0 && storeinfo.newFlag !== 'Y'">
                            <div class="cardinfo" v-for="(air, index) in airdata" :key="index">
                              <div style="display: flex;justify-content: space-between;">
                                <div>空调 {{index + 1}}</div>
                              </div>
                              <div style="text-align: center;">
                                <el-button type="success" @click="publishAirCommand(air,'860100000087')">打开</el-button>
                                <el-button type="danger" @click="publishAirCommand(air,'860100010086')">关闭</el-button>
                              </div>
                            </div>
                        </el-col>
                    </el-row>
                  <el-row :gutter="10" v-if="storeinfo.newFlag === 'Y'">
                    <el-col :span="8" :key="index" v-for="(con, index) in controls">
                      <div class="cardinfo">
                        <div style="display: flex;justify-content: space-between;">
                          <div>{{con.name}}</div>
                          <div>
                            <el-tag type="success" v-if="con.openFlag === 'Y'">开启</el-tag>
                            <el-tag type="danger" v-else>关闭</el-tag>
                          </div>
                        </div>
                        <div style="text-align: center;">
                          <el-button type="success" @click="publishLightCommandNew(con,'OPEN', 'Y', index)">开启</el-button>
                          <el-button type="danger" @click="publishLightCommandNew(con,'CLOSE', 'N', index)">关闭</el-button>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="lyControls.length > 0 && storeinfo.newFlag === 'Y'">
                    <el-col :span="8" :key="index" v-for="(ly, index) in lyControls">
                        <div class="cardinfo">
                          <div style="display: flex;justify-content: space-between;">
                            <div>淋浴{{index + 1}}</div>
                            <div>
                              <el-tag type="success" v-if="ly.openFlag === 'Y'">开启</el-tag>
                              <el-tag type="danger" v-else>关闭</el-tag>
                            </div>
                          </div>
                          <div style="text-align: center;">
                            <el-button type="success" @click="publishBathCommandNew(ly,'Y', index)">开启</el-button>
                            <el-button type="danger" @click="publishBathCommandNew(ly,'N', index)">关闭</el-button>
                          </div>
                        </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="airdata.length > 0 && storeinfo.newFlag === 'Y'">
                    <el-col :span="8" :key="index" v-for="(air, index) in airdata">
                        <div class="cardinfo">
                          <div style="display: flex;justify-content: space-between;">
                            <div>{{air.name}}</div>
                            <div>
                              <el-tag type="success" v-if="air.openFlag === 'Y'">开启</el-tag>
                              <el-tag type="danger" v-else>关闭</el-tag>
                            </div>
                          </div>
                          <div style="text-align: center;">
                            <el-button type="success" @click="publishAirCommandNew(air,'Y', index)">打开</el-button>
                            <el-button type="danger" @click="publishAirCommandNew(air,'N', index)">关闭</el-button>
                          </div>
                        </div>
                    </el-col>
                  </el-row>
                </el-card>
            </el-tab-pane>
            <el-tab-pane label="应急门" name="third">
                <el-card v-loading="usrDeviceLoading">
                    <div slot="header" style="font-size: 20px">
                        <span>门店：{{storeinfo.Storename}}</span>
                        <el-button icon="el-icon-refresh" style="float: right; padding: 3px 0;font-size: 16px;" type="text" @click="getUsrDeviceList"></el-button>
                    </div>
                    <el-row :gutter="10">
                        <el-col :span="8" :key="item.id" v-for="item in usrDeviceList">
                            <div class="cardinfo">
                                <div style="display: flex;justify-content: space-between;">
                                    <div>{{ item.gatewayName || item.usrSn }}</div>
                                    <div>
                                        <el-tag type="success" size="mini" v-if="item.usrStatus === 'Y'">在线</el-tag>
                                        <el-tag type="info" size="mini" v-else-if="item.usrStatus === 'N'">离线</el-tag>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <el-button type="success" @click="usrDoorAlwaysOpen(item)">常开</el-button>
                                    <el-button type="danger" @click="usrDoorClose(item)">关门</el-button>
                                  <!-- <el-button type="warning" @click="usrDoorTimedOpen(item)">限时开门（10分钟）</el-button> -->
                              </div>
                          </div>
                      </el-col>
                  </el-row>
                  <div v-if="!usrDeviceLoading && usrDeviceList.length === 0" style="text-align: center; color: #999; padding: 40px 0; font-size: 16px;">
                      暂无应急门设备
                  </div>
              </el-card>
          </el-tab-pane>
      </el-tabs>

      <!-- 发放会员卡对话框 -->
        <el-dialog title="发放会员卡" :visible.sync="giftDialogVisible" width="60%" @close="giftDialogClosed">
        <el-form :model="giftForm" :rules="giftFormRules" ref="giftFormRef" label-width="100px">
            <el-form-item label="手机号" prop="username">
                <el-select v-model="giftForm.username" filterable multiple placeholder="请选择会员手机号" style="width: 80%;" :remote="true" :remote-method="fetchUsernames" :loading="loadingUsernames">
                    <el-option
                        v-for="item in usernames"
                        :key="item.Id"
                        :label="item.Username"
                        :value="item.Username">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用门店" prop="storeid">
                <el-select filterable v-model="giftForm.storeid" @change="handleStoreChange" placeholder="请选择门店" style="width: 80%;">
                    <el-option
                        v-for="item in storelist"
                        :key="item.id"
                        :label="item.storename"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="会员卡" prop="cardid">
                <el-select v-model="giftForm.cardid" placeholder="请选择会员卡" style="width: 80%;">
                    <el-option
                        v-for="item in cards"
                        :key="item.Id || item.id"
                        :label="`${item.Cardname || item.cardname} - ¥${item.amount || item.Amount || item.Price || item.price || 0}`"
                        :value="item.Id || item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="giftDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveGiftCard">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
// ✅ 封装可复用的 sleep 工具函数
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
export default {
    data() {
        return {
            activeName: 'first',
            queryInfo: {
                storeid:1,
                query: '',
                pagenum: 1,
                pagesize: 20
            },
            total: 0,
            userList: [],
            storelist:[],
            avatar:'https://img.36krcdn.com/20220222/v2_6dc8e5fe70614460a81571681a8f1032_img_000',
            dialogVisible: false, // 控制对话框显示
            username:'',
            face:'',
            storeinfo:{},
            Loading:false,
            // 门禁开锁防抖控制
            doorCommandCooldown: false,
            // 发放会员卡相关数据
            giftDialogVisible: false,
            giftForm: {
                username: [],
                cardid: '',
                storeid: '',
                remark: ''
            },
            giftFormRules: {
                username: [
                    { required: true, message: '请选择手机号', trigger: 'blur' }
                ],
                cardid: [
                    { required: true, message: '请选择会员卡', trigger: 'blur' }
                ],
                storeid: [
                    { required: true, message: '请选择门店', trigger: 'blur' }
                ],
            },
            usernames: [],
            loadingUsernames: false,
            cards: [],

            far:'',
          control: [],
          airdata: [],
          lyControls: [],
          controls: [],
          // 应急门（USR设备）列表
          usrDeviceList: [],
          usrDeviceLoading: false,
          // 应急门开锁防抖控制
          usrDoorCooldown: false
        }
    },
    watch: {
        // 监听路由变化
        '$route': {
            handler(to, from) {
                // 只有当路由是customer-store-info时才调用GetStoreInfo
                if (to.path.includes('/customer-store-info')) {
                    // 如果storeid变化了，更新并获取新的门店信息
                    const id = to.params.id;
                    if (id && !isNaN(Number(id))) {
                        this.queryInfo.storeid = Number(id);
                        this.GetStoreInfo();
                        if (this.activeName === 'third') {
                            this.getUsrDeviceList()
                        }
                    }
                }
            },
            immediate: false // 不在组件创建时立即执行
        }
    },
    created() {
        // 检查路由参数是否存在且有效，否则使用默认值1
        const id = this.$route.params.id;
        this.queryInfo.storeid = id && !isNaN(Number(id)) ? Number(id) : 1;
        this.getList()
        this.GetStore()

        // 只有当前路由是customer-store-info时才调用GetStoreInfo
        if (this.$route.path.includes('/customer-store-info')) {
            this.GetStoreInfo()
        }
    },
    methods: {
        TabClick(tab) {
            if(tab.name == 'first'){
                this.getList()
            }else if(tab.name == 'second'){
                // this.publishMessage('AT\r\n')
            }else if(tab.name == 'third'){
                this.getUsrDeviceList()
            }
        },
        // 获取应急门（USR设备）列表
        async getUsrDeviceList() {
            const storeId = isNaN(this.queryInfo.storeid) ? 1 : this.queryInfo.storeid
            this.usrDeviceLoading = true
            try {
                const { data: res } = await this.$http.get('device/usr/listByStore', { params: { storeId: storeId } })
                if (res.status === 0 || res.code === 200) {
                    this.usrDeviceList = res.data || []
                } else {
                    this.$message.error(res.msg || '获取应急门设备列表失败')
                    this.usrDeviceList = []
                }
            } catch (error) {
                console.error('获取应急门设备列表异常:', error)
                this.$message.error('获取应急门设备列表失败: ' + (error.message || '未知错误'))
                this.usrDeviceList = []
            } finally {
                this.usrDeviceLoading = false
            }
        },
        // 应急门-常开
        async usrDoorAlwaysOpen(row) {
            await this.usrControlDoor(row.usrSn, 'OPEN', '常开')
        },
        // 应急门-关门
        async usrDoorClose(row) {
            await this.usrControlDoor(row.usrSn, 'CLOSE', '关门')
        },
        // 应急门-限时开门10分钟
        async usrDoorTimedOpen(row) {
            await this.usrControlDoor(row.usrSn, 'TIMED_OPEN', '限时开门')
        },
        // 应急门控制统一请求
        async usrControlDoor(usrSn, action, label) {
            // 检查是否在冷却期内
            if (this.usrDoorCooldown) {
                this.$message.warning('操作过于频繁，请稍后再试')
                return
            }
            // 设置冷却期
            this.usrDoorCooldown = true
            try {
                const { data: res } = await this.$http.post('device/usr/controlDoor', { usrSn, action })
                if (res.status === 0 || res.code === 200) {
                    this.$message.success(`${label}指令已发送`)
                } else {
                    this.$message.error(res.msg || `${label}操作失败`)
                }
            } catch (error) {
                console.error(`应急门${label}异常:`, error)
                this.$message.error(`${label}操作失败: ` + (error.message || '未知错误'))
            } finally {
                // 2秒后解除冷却期
                setTimeout(() => {
                    this.usrDoorCooldown = false
                }, 2000)
            }
        },
      // 发布门禁命令(A)
      async publishDoorCommandA(sn, topic,command) {
        // 检查是否在冷却期内
        if (this.doorCommandCooldown) {
          this.$message.warning('操作过于频繁，请稍后再试')
          return
        }

        // 设置冷却期
        this.doorCommandCooldown = true
        try {
          const { data:res } = await this.$http.get(this.deviceURL+'mdoorA?topic=' + topic + '&command=' + command + '&faceLocal=' + this.storeinfo.faceLocal + '&sn=' + sn)
          if(res.status===0)
          {
            this.$message.success('门禁指令已发送！')
          } else {
            this.$message.error('门禁指令发送失败');
          }
        } catch (error) {
          this.$message.error('门禁指令发送失败');
        } finally {
          // 2秒后解除冷却期
          setTimeout(() => {
            this.doorCommandCooldown = false
          }, 2000)
        }
      },

      // 发布门禁命令
      async publishDoorCommand(sn, topic, command) {
        // 检查是否在冷却期内
        if (this.doorCommandCooldown) {
          this.$message.warning('操作过于频繁，请稍后再试')
          return
        }

        // 设置冷却期
        this.doorCommandCooldown = true
        try {
          const { data:res } = await this.$http.get(this.deviceURL+'mdoor?topic=' + topic + '&command=' + command + '&faceLocal=' + this.storeinfo.faceLocal + '&sn=' + sn)
          if(res.status===0)
          {
            this.$message.success('门禁指令已发送！')
          } else {
            this.$message.error('门禁指令发送失败');
          }
        } catch (error) {
          this.$message.error('门禁指令发送失败');
        } finally {
          // 2秒后解除冷却期
          setTimeout(() => {
            this.doorCommandCooldown = false
          }, 2000)
        }
      },

        // 发布照明命令
        async publishLightCommand(boxSn,command) {
          const { data:res } = await this.$http.post('mqtt/operatorLight', {boxSn,command})
          if(res.status===0)
          {
            this.$message.success(`灯已${command === 'a1' ? '打开' : '关闭'}`)
          } else {
            this.$message.error('照明指令发送失败');
          }
        },
        // 发布照明命令(新设备)
        async publishLightCommandNew(row,operator, openFlag, index) {
          if (this.storeinfo.upDeviceTopic) {
            const { data:res } = await this.$http.post('mqtt/operatorControl', {
              operator, port: row.relayNum, openFlag, id: row.id, topic: this.storeinfo.upDeviceTopic,
              type: row.controlType, controlIp: row.controlIp
            })
            if(res.status===0)
            {
              row.openFlag = openFlag
              this.$set(this.controls, index, row)
              this.$message.success(`已${operator === 'OPEN' ? '打开' : '关闭'}`)
            } else {
              this.$message.error('指令发送失败');
            }
          } else {
            this.$message.error('门店未设置上位机TOPIC指令不可发送');
          }
        },
        // 发布淋浴命令
        async publishBathCommand(topic, command) {
          const { data:res } = await this.$http.post('mqtt/operatorLyOld', {
            topic, command
          })
          if(res.status===0)
          {
            this.$message.success(`淋浴已${command === 'a1' || command === 'a2' || command === 'a3' || command === 'a4' ? '打开' : '关闭'}`)
          } else {
            this.$message.error('淋浴指令发送失败');
          }
        },
        // 发布淋浴命令(新设备)
        async publishBathCommandNew(row, openFlag, index) {
          const loading = this.$loading({
            lock: true,
            text: '淋浴操控中。。。',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          if (this.storeinfo.upDeviceTopic) {
            if (openFlag === 'Y') {
              const { data:res } = await this.$http.post('openBath', {
                storeId: row.storeId,
                lyIp: row.lyIp,
                port: row.port,
                username: 'admin',
                time: row.time,
                topic: row.topic,
                operatorUser: 'system'
              })
              if(res.status===2)
              {
                let i = 0
                while (i < 6) {
                  i++
                  await sleep(2000); // ⏳ 等待2秒，期间不阻塞其他任务

                  const { data:res2 } = await this.$http.get('checkBathStatus', { params:{key: res.key} })
                  if (res2.status != 2) {
                    loading.close()
                    if (res2.status == 0) {
                      row.openFlag = openFlag
                      row.userName = 'admin'
                      this.$set(this.lyControls, index, row)
                      this.$message.success(`淋浴已打开`)
                    } else {
                      this.$message.error(res2.msg);
                    }
                    break;
                  }
                }
              } else if (res.refresh) {
                await this.GetStoreInfo()
                loading.close()
                this.$message.error(res.msg);
              } else {
                loading.close()
                this.$message.error(res.msg);
              }
            } else {
              const { data:res } = await this.$http.post('closeBathNew', {
                storeId: row.storeId,
                lyIp: row.lyIp,
                port: row.port,
                username: 'admin',
                topic: row.topic,
                operatorUser: 'system'
              })
              console.log("===========测试关闭")
              console.log(res)
              if(res.status===2)
              {
                let i = 0
                while (i < 6) {
                  i++
                  await sleep(2000); // ⏳ 等待2秒，期间不阻塞其他任务

                  const { data:res2 } = await this.$http.get('checkBathCloseStatus', { params:{key: res.key} })
                  if (res2.status != 2) {
                    loading.close()
                    if (res2.status == 0) {
                      row.openFlag = openFlag
                      row.userName = null
                      this.$set(this.lyControls, index, row)
                      this.$message.success(`淋浴已关闭`)
                    } else {
                      this.$message.error(res2.msg);
                    }
                    break;
                  }
                }
              } else if (res.refresh) {
                await this.GetStoreInfo()
                loading.close()
                this.$message.error(res.msg);
              } else {
                loading.close()
                this.$message.error(res.msg,);
              }
            }
          } else {
            this.$message.error('门店未设置上位机TOPIC指令不可发送');
          }
        },
        // 发布空调命令
        async publishAirCommand(air,cmd) {
          const { data:res } = await this.$http.post('mqtt/operatorAirOld', {
            topic: air.Gateway, command:`{"Device":"${air.Far}","endpoint":1,"send":"0704!02/0000${cmd}"}` })
          if(res.status===0)
          {
            this.$message.success('空调指令已发送！')
          } else {
            this.$message.error('空调指令发送失败');
          }
        },
        // 发布空调命令(新设备)
        async publishAirCommandNew(air,openFlag, index) {
          if (this.storeinfo.upDeviceTopic) {
            let command = 'open'
            if (openFlag === 'N') {
              command = 'close'
            }

            const { data:res } = await this.$http.post('mqtt/operatorAir', {
              command, path: air.path, id: air.id, openFlag, port: air.port,
              topic: this.storeinfo.upDeviceTopic, airType: air.airType
            })
            if(res.status===0)
            {
              air.openFlag = openFlag
              this.$set(this.airdata, index, air)
              this.$message.success('空调指令已发送！')
            } else {
              this.$message.error('空调指令发送失败');
            }
          } else {
            this.$message.error('门店未设置上位机TOPIC指令不可发送');
          }
        },
        async getList(){
            this.Loading = true
            // 使用新的 userlistwithcard 接口获取包含购卡关联的会员列表
            const { data:res } = await this.$http.get('userlistwithcard/',{
                params: {
                    storeid: this.queryInfo.storeid,
                    query: this.queryInfo.query,
                    p: this.queryInfo.pagenum,
                    pagesize: this.queryInfo.pagesize
                }
            })

            // 新的后端接口返回格式与原来的不同，直接处理
            if(res.code === 0){ // 新接口返回 code=0 表示成功
                // 直接使用返回的数据，不需要再调用 usercards 接口
                console.log('原始返回数据:', JSON.stringify(res));
                console.log('第一个会员数据结构:', res.data && res.data.length > 0 ? JSON.stringify(res.data[0]) : '无数据');

                // 深度检查数据结构
                if (res.data && res.data.length > 0) {
                    const firstUser = res.data[0];
                    console.log('用户名:', firstUser.username);
                    console.log('门店ID:', firstUser.storeid);
                    console.log('卡信息数组:', firstUser.cards);
                    if (firstUser.cards && firstUser.cards.length > 0) {
                        console.log('第一张卡信息:', JSON.stringify(firstUser.cards[0]));
                    } else {
                        console.log('没有卡信息');
                    }
                }

                this.userList = res.data;
                console.log('会员列表数据:', JSON.stringify(this.userList));
                this.total = res.total;
                this.Loading = false;
            } else {
                this.$message.error(res.msg || '获取会员列表失败');
                this.Loading = false;
            }
            this.GetStoreInfo()
        },
        // 显示大图对话框
        showLargeAvatar(username) {
            this.username = username;
            this.face = `${this.ossURL}${username}.png?t='${Date.now()}`;
            // this.face = this.ossURL + this.userInfo.Username + '.png?t=' + Date.now();
            this.dialogVisible = true;
        },
        // 处理行点击事件
        handleRowClick(row) {
            console.log(row);
            const username = row.username
            this.$router.push({path: '/userinfo', query: { storeid: row.storeid, username}})
        },
        handleSizeChange(newSize){
            this.queryInfo.pagesize = newSize
            this.getList()
        },
        handleCurrentChange(newPage){
            this.queryInfo.pagenum = newPage
            this.getList()
        },
        async GetStore(){
            const { data: res } = await this.$http.get('stores/')
            if(res.code == 0){
                this.storelist = res.data
            }
       },
      async GetStoreInfo(){
        // 如果不是在customer-store-info路由下，不执行请求
        if (!this.$route.path.includes('/customer-store-info')) {
          console.log('当前不在门店详情页面，跳过API调用');
          return;
        }
          try {
            // 确保 storeid 不为 NaN
            const storeid = isNaN(this.queryInfo.storeid) ? 1 : this.queryInfo.storeid;
            console.log(`正在获取门店ID: ${storeid} 的完整信息`);

            // 使用新的API接口 stores/full_info 替代 stores/info
            const { data: res } = await this.$http.post('stores/full_info',{storeid: storeid})
            console.log(res,"获取门店完整信息");

            if(res.code == 0){
              this.storeinfo = res.data
              this.lyControls = res.lyControls
              this.airdata = res.airdata
              this.controls = res.controls
              console.log("====控制器：")
              console.log(this.controls)
            } else {
              console.error('获取门店信息失败:', res.msg || '未知错误');
              this.$message.error(res.msg || '获取门店信息失败');
            }
          } catch (error) {
            console.error('获取门店信息异常:', error);
            this.$message.error('获取门店信息失败: ' + (error.message || '未知错误'));
          }
      },
      // 发放会员卡相关方法
      showGiftCardDialog() {
        this.giftDialogVisible = true
        // 默认使用当前选中的门店
        this.giftForm.storeid = this.queryInfo.storeid
        // 获取门店对应的会员卡
        this.getCards(this.giftForm.storeid)
      },
      // 获取门店的会员卡列表
      async getCards(storeid) {
        if (!storeid) return
        try {
          const { data: res } = await this.$http.get('cards/all', { params: {storeid: storeid}})
          if (res.code == 0) {
            console.log('原始会员卡数据:', JSON.stringify(res.data))
            if (res.data && res.data.length > 0) {
              const firstCard = res.data[0]
              console.log('第一张卡的完整数据:', JSON.stringify(firstCard))
              console.log('字段名称列表:', Object.keys(firstCard))
            }
            // 保持与原始项目一致的逻辑，过滤掉卡类ID为3的卡
            this.cards = res.data.filter(card => card.cardclassid !== 3 && card.Cardclassid !== 3)
            console.log('过滤后的会员卡列表:', JSON.stringify(this.cards))
          } else {
            this.$message.error('获取会员卡列表失败')
            this.cards = []
          }
        } catch (error) {
          console.error('获取会员卡列表异常:', error)
          this.$message.error('获取会员卡列表失败: ' + error.message)
          this.cards = []
        }
      },
      // 门店选择变化时获取对应的会员卡
      handleStoreChange(storeid) {
        this.getCards(storeid)
      },
      // 搜索会员，先从当前列表中查找，如果没有再远程搜索
      async fetchUsernames(query) {
        if (query === '' || query.length < 2) { // 至少输入2个字符才查询
          this.usernames = []
          return
        }

        // 先从当前已加载的会员列表中查找
        const localResults = this.userList.filter(user => {
          return user.username && user.username.includes(query)
        }).map(user => ({
          Id: user.id || user.userid, // 兼容不同的ID字段名
          Username: user.username
        }))

        // 如果当前列表中有匹配的结果，直接使用
        if (localResults.length > 0) {
          console.log('从当前列表中找到匹配结果:', localResults)
          this.usernames = localResults
          return
        }

        // 如果当前列表中没有匹配的结果，再进行远程搜索
        this.loadingUsernames = true
        try {
          const { data: res } = await this.$http.get('users/all', { params: { query: query } })
          if (res.code == 0) {
            console.log('远程搜索结果:', res.data)
            this.usernames = res.data
          } else {
            this.$message.error('获取会员列表失败')
          }
        } catch (error) {
          console.error('远程搜索失败:', error)
          this.$message.error('搜索失败: ' + error.message)
        } finally {
          this.loadingUsernames = false
        }
      },
      // 关闭对话框时重置表单
      giftDialogClosed() {
        this.$refs.giftFormRef.resetFields()
      },
      // 保存发放会员卡
      saveGiftCard() {
        this.Loading = true
        this.$refs.giftFormRef.validate(async valid => {
          if (!valid) {
            this.Loading = false
            return
          }

          // 与原始项目保持一致
          try {
            // 添加服务令牌，与原始项目保持一致
            if (this.service_token) {
              this.giftForm.service_token = this.service_token
            }

            // 将 username 数组转换为字符串，与后端接口保持一致
            const requestData = {
              ...this.giftForm,
              username: this.giftForm.username.length > 0 ? this.giftForm.username[0] : ''
            }

            console.log('发送发卡请求:', requestData)
            const { data: res } = await this.$http.post('cards/gift', requestData)

            if (res.code == 0) {
              this.$message.success('发卡成功')
              this.giftDialogVisible = false

              // 刷新会员列表
              this.getList()

              // 如果有卡记录列表方法，也要刷新
              if (typeof this.getGiftCardList === 'function') {
                this.getGiftCardList()
              }
            } else {
              this.$message.error(res.msg || '发卡失败')
            }
          } catch (error) {
            console.error('发卡异常:', error)
            this.$message.error('发卡失败: ' + error.message)
          } finally {
            this.Loading = false
          }
        })
      }
    }
}
</script>
<style scoped>

    .el-breadcrumb{
        margin: 0;
        font-size: 18px;
    }
    .el-avatar:hover {
        transform: scale(1.05);
        transition: transform 0.3s;
    }
    ::v-deep .el-tabs__item{
        font-size: 18px;
        height: 50px;
    }
    .cardinfo{
        height: 100px;
        border:1px dashed #ccc;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 10px;
      flex: 1;
    }
    .el-tag{
        font-size: 16px;
    }
    .store-stat {
        display: flex;
        align-items: center;
        font-size: 16px;
        background-color: #f5f7fa;
        padding: 10px 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    }
    .store-stat i {
        color: #409EFF;
        font-size: 20px;
        margin-right: 8px;
    }
</style>
